import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-g_cart_on",
  "use": "icon-g_cart_on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-g_cart_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M223.072 950.848a73.088 73.088 0 1 1 146.176-0.064 73.088 73.088 0 0 1-146.176 0.064z m580.8 0a73.088 73.088 0 1 1 146.24-0.064 73.088 73.088 0 0 1-146.24 0.064zM1001.184 252.352c18.24 21.952 25.6 51.2 21.888 80.448l-58.432 387.648c-7.296 47.552-51.2 84.096-102.272 84.096H307.104c-51.2 0-94.976-43.84-102.336-98.688L146.336 281.6 113.504 102.4c-3.648-18.304-18.24-29.248-32.832-29.248H36.704A36.608 36.608 0 0 1 36.704 0h43.84c54.784 0 98.56 40.256 105.92 91.456l25.6 128h715.968c29.248 0 54.784 10.944 73.088 32.896z\" p-id=\"6227\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/g_cart_on.svg
// module id = WWiL
// module chunks = 31